export const checkUrlValidity = (url) => {
  try {
      const u = new URL(url);
      if (!(u.protocol === 'http:' || u.protocol === 'https:')) return false;
      // Hostname checks
      const host = u.hostname;
      // Must not be empty, must not be an IP address (optional)
      if (!host || host.length < 4) return false;
      // Split domain and tld
      const parts = host.split('.');
      if (parts.length < 2) return false;
      const tld = parts[parts.length - 1];
      const domain = parts[parts.length - 2];
      // Domain must have at least 1 character
      if (!domain || domain.length < 1) return false;
      // TLD must have at least 2 characters and only letters
      if (!/^[a-zA-Z]{2,}$/.test(tld)) return false;
      // Optionally, check for invalid characters in domain
      if (!/^[a-zA-Z0-9-]+$/.test(domain)) return false;
      // Optionally, check for localhost
      if (host === 'localhost') return true;
      // Optionally, check for reserved or private IPs (skip for now)
      return true;
    } catch {
      return false;
    }
};
